import { useDispatch } from "react-redux";
import styled from "styled-components";
import { addFilter, removeFilter } from "../../../actions";


export default function CheckBoxNew({ label, checked, onChange,key, value,title }) {
  
  

  console.log(label, checked, onChange, key, value, "CheckBoxNew");
  
    const ContainerCheckbox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: .3rem 0;


    .checkbox-container{
    padding: .1rem;
    }
    

    `

    const Label = styled.label`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    font-size: 11px;
    color: #999;
    `

    const CheckboxInput = styled.input`
    type: checkbox;
    width: 11px;
    height: 11px;
    margin-right: 0.5rem;

    accent-color: #4EB7CE;

    &:checked {
        background-color: #4EB7CE;
        border: 1px solid #4EB7CE;
        }

    `
  
    const LabelWrapper = styled.label`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem;
  cursor: pointer;
  user-select: none;
  border-radius: 6px;

  &:hover {
    background-color: #f4f4f4;
  }
`;
    const dispatch = useDispatch();

  const handleFacetChange = (e) => {
    if (e.target.checked) {
      const [id, value] = e?.target?.id?.split(":");
      dispatch(addFilter({ id, value }));
    } else if (!e.target.checked) {
      const [id, value] = e?.target?.id?.split(":");
      dispatch(removeFilter({ id, value }));
    }
  };

    return (
    <ContainerCheckbox>
      <LabelWrapper>
  <CheckboxInput type="checkbox"  id={`${title}:${label}`} value={value} checked={checked} onChange={handleFacetChange} />


     <Label>
        {label}
     </Label>
      </LabelWrapper>




       
    </ContainerCheckbox>
  );
}